import { Modal } from "@/components/molecules/Modal";
import { ProUpgradeFunnel, type ProUpgradeFunnelProps } from "./ProUpgradeFunnel";

export interface ProUpgradeModalProps extends Omit<ProUpgradeFunnelProps, "variant"> {
  isOpen: boolean;
  onClose: () => void;
}

export function ProUpgradeModal({
  isOpen,
  onClose,
  featureId,
  title,
  description,
  showFeatureGrid,
}: ProUpgradeModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="BurnChart Pro" size="xl">
      <ProUpgradeFunnel
        featureId={featureId}
        variant="hero"
        title={title}
        description={description}
        showFeatureGrid={showFeatureGrid ?? false}
        className="border-0 bg-transparent ring-0"
      />
    </Modal>
  );
}
